















import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosVersao extends Vue {

    get loadingVersao () {
        return this.$store.state.loading_versao;
    }

    get listaVersoes () {
        return this.$store.state.versoes;
    }

    get versao () {
        return this.$store.state.cotacao.versao;
    }

    set versao ( value ) {
        this.$store.dispatch("SET_VERSAO", value).then();
    }

    get errorVersao () {
        return this.$store.state.errors.versao;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
